import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Stack, Box, Button } from '@mui/material';
import Typography from '@mui/material/Typography';
import errorSvg from 'assets/images/404.svg';
import { BACK_TO_DEBATES } from 'shared/constants/buttons-constants';
import { PAGE_PLACEHOLDERS_DATA } from 'shared/constants/no-content-constants';
import { urls } from 'shared/constants/routing.constants';

export const NotFound: React.FC = () => {
  const navigate = useNavigate();

  const handleReturnToDebates = () => {
    navigate(urls.commonPages.home);
  };

  return (
    <Stack
      sx={{
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#000026',
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100vw',
        padding: { lg: '44px', md: '22px', sm: '22px', xs: '22px' },
        zIndex: 100,
      }}
    >
      <Box
        component="img"
        src={errorSvg}
        alt="404"
        style={{
          filter: 'drop-shadow(5px -3px 0 #B10026) drop-shadow(-5px 3px 0 #00FFFF)',
        }}
        sx={{
          mb: { md: '11px', sm: '22px', xs: '22px' },
          maxHeight: { md: '288px', sm: '130px', xs: '130px' },
        }}
      />
      <Typography
        variant="overline"
        color="primary.contrastText"
        sx={{
          marginBottom: { md: '2rem', sm: '160px', xs: '160px' },
          textTransform: 'none',
          fontSize: { md: 32, sm: 22, xs: 22 },
        }}
      >
        {PAGE_PLACEHOLDERS_DATA.pageNotFound}
      </Typography>
      <Button
        variant="leave"
        sx={{ width: { md: '244px', sm: '331px', xs: '100%' } }}
        onClick={handleReturnToDebates}
      >
        {BACK_TO_DEBATES}
      </Button>
    </Stack>
  );
};
